/**
 * lineOfSight — Pure 2D LoS vs wall AABB boxes (SPY-14 / SPY-106).
 * Contrato: hasLineOfSight(ax, az, bx, bz, wallBoxes?) → boolean
 * Corner-graze contacts count as blocked (t0 <= t1).
 */

/**
 * True when the open segment between (ax,az) and (bx,bz) does not hit any wall AABB.
 */
export function hasLineOfSight(ax, az, bx, bz, wallBoxes = []) {
  if (!wallBoxes.length) return true;
  return !wallBoxes.some((box) => segmentHitsAabb(ax, az, bx, bz, box));
}

function segmentHitsAabb(ax, az, bx, bz, box) {
  if (!box) return false;
  const { minX, maxX, minZ, maxZ } = box;
  if (pointInAabb(ax, az, minX, maxX, minZ, maxZ)) return true;
  if (pointInAabb(bx, bz, minX, maxX, minZ, maxZ)) return true;

  let t0 = 0;
  let t1 = 1;
  const dx = bx - ax;
  const dz = bz - az;
  const clips = [
    [-dx, ax - minX],
    [dx, maxX - ax],
    [-dz, az - minZ],
    [dz, maxZ - az]
  ];

  for (let i = 0; i < clips.length; i++) {
    const p = clips[i][0];
    const q = clips[i][1];
    if (p === 0) {
      if (q < 0) return false;
      continue;
    }
    const r = q / p;
    if (p < 0) {
      if (r > t1) return false;
      if (r > t0) t0 = r;
    } else {
      if (r < t0) return false;
      if (r < t1) t1 = r;
    }
  }
  return t0 <= t1;
}

function pointInAabb(x, z, minX, maxX, minZ, maxZ) {
  return x >= minX && x <= maxX && z >= minZ && z <= maxZ;
}
